import { Component, OnInit } from "@angular/core";
import { RestService } from "src/app/services/rest.service";

@Component({
  selector: "app-partner-app-paid",
  templateUrl: "./partner-app-paid.component.html",
  styleUrls: ["./partner-app-paid.component.css"],
})
export class PartnerAppPaidComponent implements OnInit {
  model: any[] = [];
  currentPage = 1;
  limit = 40;
  total = 0;
  totalPages = 1;

  constructor(private rest: RestService) {}

  ngOnInit() {
    this.getAllVisit();
  }

  getAllVisit() {
    const auth = JSON.parse(localStorage.getItem("partnerAuthen"));
    if (auth) {
      const partner_id = auth.partner_id;
      this.rest
        .getAllAppPaid(partner_id, this.currentPage, this.limit)
        .subscribe((rs) => {
          this.model = rs.data;
          this.total = rs.total;
          this.totalPages = rs.totalPages;
          console.log("Response: ", rs);
        });
    }
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.getAllVisit();
  }

  get pages(): (number | "...")[] {
    const total = this.totalPages;
    const cur = this.currentPage;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const result: (number | "...")[] = [1];
    if (cur > 3) result.push("...");
    for (let i = Math.max(2, cur - 1); i <= Math.min(total - 1, cur + 1); i++)
      result.push(i);
    if (cur < total - 2) result.push("...");
    result.push(total);
    return result;
  }
}
